import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    role: { type: String },
    retry: { type: Number, default: 0 },
    initialDelay: { type: Number, default: 2000},
    retryInterval: { type: Number, default: 5000}
  }

  static targets=  ["progress", "ok", "fail", "retry", "message"]

  static outlets = [ "submit" ] // the parent

  retryCallback;

  log(msg) {
    console.log("Submit stage " + this.roleValue + ": " + msg)
  }

  start(message = null) {
    this.hideStatus();
    this.retryCallback = null;
    this.messageTarget.textContent = message
    this.element.classList.add("animate-pulse")
    this.element.classList.remove("opacity-50")
    this.progressTarget.classList.remove("hidden")
  }

  success(message = null) {
    this.done();
    this.messageTarget.textContent = message
    this.okTarget.classList.remove("hidden")
  }

  fail(message) {
    this.done();
    this.messageTarget.textContent = message
    this.failTarget.classList.remove("hidden")
  }

  retryable(message, callback) {
    this.done();
    this.retryCallback = callback;
    this.messageTarget.textContent = message
    this.retryTarget.classList.remove("hidden")
  }

  retry() {
    if (typeof this.retryCallback === 'function') {
      this.retryCallback();
    } else {
      console.log("Failed to retry. Internal Error.")
      this.messageTarget.textContent = "Failed to retry. Internal Error."
    }
  }

  hideStatus() {
    this.progressTarget.classList.add("hidden")
    this.okTarget.classList.add("hidden")
    this.failTarget.classList.add("hidden")
    this.retryTarget.classList.add("hidden")
    this.element.classList.remove("animate-pulse")
  }

  done() {
    this.log("done!")
    this.hideStatus();
    this.retryCallback = null;
  }

  reset() {
    this.hideStatus();
    this.element.classList.add("opacity-50")
    this.messageTarget.textContent = ""
  }

  hide() {
    this.element.classList.add("hidden")
  }

  show() {
    this.element.classList.remove("hidden")
  }
}
